import React from 'react';

export default <img src={`${ASSETS_BASE_DIR}/logo.png`} style={{ height: '42px', margin: '0 auto' }} />;
